<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <b-row class="ml-1 mt-1 mr-1">
          <b-col sm="8" class="justify-content-center">
            <h4>RTPS Metrics</h4>
          </b-col>
          <b-col sm="4" class="justify-content-center">
            <b-form-group label-cols-sm="3" label="Date Range">
              <date-picker
                v-model="selectedRange"
                class="form-control"
                type="date"
                :not-after="new Date()"
                lang="en"
                range
                :shortcuts="rangeShortcut"
                format="YYYY-MM-DD"
                range-separator="thru"
                @confirm="refresh"
                :confirm="true"
              ></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col lg="6">
            <img
              v-if="PatientSavingsTimeSeries"
              :src="`data:image/png;base64,${PatientSavingsTimeSeries}`"
            />
          </b-col>
          <b-col lg="6">
            <img
              v-if="RxDispositionTimeSeries"
              :src="`data:image/png;base64,${RxDispositionTimeSeries}`"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2 ml-1">
          <b-col lg="6">
            <h6>Patient Savings Response Time</h6>
          </b-col>
          <b-col lg="6">
            <h6>Rx Disposition Response Time</h6>
          </b-col>
        </b-row>
        <b-row class="text-center mt-1 ml-1">
          <b-col lg="1">
            <h4>{{ PatientSavingsSingleValue.min ? Math.round(PatientSavingsSingleValue.min) + " ms" : "N/A"}}</h4>
          </b-col>
          <b-col lg="1">
            <h4>{{ PatientSavingsSingleValue.max ? Math.round(PatientSavingsSingleValue.max) + " ms" : "N/A"}}</h4>
          </b-col>
          <b-col lg="1">
            <h4>{{ PatientSavingsSingleValue.avg ? Math.round(PatientSavingsSingleValue.avg) + " ms" : "N/A"}}</h4>
          </b-col>
          <b-col lg="1" offset="3">
            <h4>{{ RxDispositionSingleValue.min ? Math.round(RxDispositionSingleValue.min) + " ms" : "N/A"}}</h4>
          </b-col>
          <b-col lg="1">
            <h4>{{ RxDispositionSingleValue.max ? Math.round(RxDispositionSingleValue.max) + " ms" : "N/A"}}</h4>
          </b-col>
          <b-col lg="1">
            <h4>{{ RxDispositionSingleValue.avg ? Math.round(RxDispositionSingleValue.avg) + " ms" : "N/A"}}</h4>
          </b-col>
        </b-row>
        <b-row class="text-center ml-1">
          <b-col lg="1">Minimum</b-col>
          <b-col lg="1">Maximum</b-col>
          <b-col lg="1">Average</b-col>
          <b-col lg="1" offset="3">Minimum</b-col>
          <b-col lg="1">Maximum</b-col>
          <b-col lg="1">Average</b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { RTPS_METRICS, RTPS_STATISTICS } from "../store/rtps/rtps.actions";
import { mapState } from "vuex";

export default {
  name: "RTPSMetrics",
  components: {
    DatePicker
  },
  data() {
    return {
      selectedRange: [getStartDate(), getEndDate()],
      rangeShortcut: [
        {
          text: "previous 24 hours",
          onClick: () => {
            let d = new Date();
            d.setDate(d.getDate() - 1);
            this.selectedRange = [d, new Date()];
          }
        },
        {
          text: "previous 7 days",
          onClick: () => {
            let d = new Date();
            d.setDate(d.getDate() - 7);
            d.setHours(0, 0, 0, 0);
            this.selectedRange = [d, getEndDate()];
          }
        },
        {
          text: "previous 30 days",
          onClick: () => {
            let d = new Date();
            d.setDate(d.getDate() - 30);
            d.setHours(0, 0, 0, 0);
            this.selectedRange = [d, getEndDate()];
          }
        }
      ]
    };
  },
  computed: {
    ...mapState({
      PatientSavingsTimeSeries: state =>
        state.rtps.metrics.PatientSavingsTimeSeries,
      PatientSavingsSingleValue: state =>
        state.rtps.metrics.PatientSavingsSingleValue,
      RxDispositionTimeSeries: state =>
        state.rtps.metrics.RxDispositionTimeSeries,
      RxDispositionSingleValue: state =>
        state.rtps.metrics.RxDispositionSingleValue
    })
  },
  created: function() {
    this.refresh();
  },
  watch: {
    selectedRange(newvalue) {
      // this.refresh();
    }
  },
  methods: {
    refresh() {
      console.log("refresh");
      this.$store.dispatch(
        RTPS_METRICS,
        this.getCriteria("PatientSavingsTimeSeries")
      );
      this.$store.dispatch(
        RTPS_STATISTICS,
        this.getCriteria("PatientSavingsSingleValue")
      );
      this.$store.dispatch(
        RTPS_METRICS,
        this.getCriteria("RxDispositionTimeSeries")
      );
      this.$store.dispatch(
        RTPS_STATISTICS,
        this.getCriteria("RxDispositionSingleValue")
      );
    },
    getCriteria(view) {
      this.selectedRange[0].setHours(0, 0, 0, 0);
      var end = new Date(this.selectedRange[1].toUTCString());
      end.setHours(0, 0, 0, 0);
      end.setDate(end.getDate() + 1);
      return {
        view: view,
        start: new Date(this.selectedRange[0].toUTCString()).toISOString(),
        end: new Date(end.toUTCString()).toISOString()
      };
    }
  }
};

function getStartDate() {
  let startDate = new Date();
  startDate.setDate(startDate.getDate() - 7);
  startDate.setHours(0, 0, 0, 0);
  return startDate;
}

function getEndDate() {
  let endDate = new Date();
  endDate.setHours(23, 59, 59, 999);
  return endDate;
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/RTPSMetrics.vue